import React from 'react';
import { motion } from 'framer-motion';

const TimelineTemplate = ({ params }) => {
  const events = params?.events || [];

  if (events.length === 0) {
    return <p style={{ color: 'var(--panel-text-secondary)' }}>No timeline data available.</p>;
  }

  return (
    <div className="timeline">
      <div className="timeline__line" />
      {events.map((event, index) => (
        <motion.div
          className="timeline__event"
          key={index}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.08, duration: 0.3, ease: [0.32, 0.72, 0, 1] }}
        >
          <div className="timeline__dot" />
          <div className="timeline__year">{event.year}</div>
          <div className="timeline__label">{event.label}</div>
          <div className="timeline__detail">{event.detail}</div>
        </motion.div>
      ))}
    </div>
  );
};

export default TimelineTemplate;
